export const DEFAULT_CHUNK_SIZE = 10 * 1024 * 1024;
